module.exports = __webpack_public_path__ + "static/AllDay-09f1056c5991cbebe87a9910d296da93.jpg";